import { DatePicker, Form, FormInstance, Input } from 'antd';
import styled from 'styled-components';

import { txt } from '../../../../locales/i18n';
import moment from 'moment';

export type CounterPanelProps = {
	propertyKey: string;
	formRef: React.RefObject<FormInstance>;
	onSectionChange: (changedValues: any, values: any) => void;
};

export const CounterPanel = (props: CounterPanelProps) => (
	<CounterPanelStyled>
		<div className="row-container">
			<div>
				<label>{txt('cms.date')}</label>
				<Form.Item
					getValueProps={(value) => ({ value: moment(value) })}
					name={[props.propertyKey, 'date']}
				>
					<DatePicker showTime />
				</Form.Item>
			</div>

			<div>
				<label>{txt('cms.color')}</label>
				<Form.Item name={[props.propertyKey, 'textColor']} noStyle>
					<Input type="color" />
				</Form.Item>
			</div>
		</div>
	</CounterPanelStyled>
);

const CounterPanelStyled = styled.div`
	.row-container {
		display: flex;
		gap: 2ch;
	}
`;
